import { differenceInSeconds } from 'date-fns';

export function press(node: HTMLButtonElement) {
  let startTime: Date | undefined;
  let count = 0;
  let animationFrameId: number | undefined;

  const frameHandler = () => {
    count++;
    node.dispatchEvent(
      new CustomEvent<{ count: number }>('press', { detail: { count } })
    );
    animationFrameId = window.requestAnimationFrame(frameHandler);
  };

  const startFrameHandler = () => {
    if (animationFrameId == undefined) {
      startTime = new Date();
      frameHandler();
    }
  };

  const releaseHandler = () => {
    let secondsPressed = 0;

    if (startTime != undefined) {
      secondsPressed = differenceInSeconds(new Date(), startTime);
    }
    if (animationFrameId != undefined) {
      window.cancelAnimationFrame(animationFrameId);
    }
    animationFrameId = undefined;
    node.dispatchEvent(
      new CustomEvent<{
        count: number;
        secondsPressed: number;
      }>('release', { detail: { count, secondsPressed } })
    );
    count = 0;
    startTime = undefined;
  };

  // Handle mouse-events
  const onMouseDown = () => {
    startFrameHandler();

    const cancel = () => {
      releaseHandler();
      node.removeEventListener('mouseleave', cancel);
      node.removeEventListener('mouseup', cancel);
    };

    node.addEventListener('mouseleave', cancel);
    node.addEventListener('mouseup', cancel);
  };
  node.addEventListener('mousedown', onMouseDown);

  // Handle touch-events
  const onTouchDown = (e: TouchEvent) => {
    e.preventDefault();
    startFrameHandler();

    const cancel = () => {
      releaseHandler();
      node.removeEventListener('touchend', cancel);
      node.removeEventListener('touchcancel', cancel);
    };

    node.addEventListener('touchend', cancel);
    node.addEventListener('touchcancel', cancel);
  };
  node.addEventListener('touchstart', onTouchDown);

  // Handle keyboard-events
  const onKeydown = (e: KeyboardEvent) => {
    if (e.key === 'Enter' || e.key === ' ') {
      const pressedKey = e.key;
      e.preventDefault();
      startFrameHandler();

      const cancel = (ev: KeyboardEvent) => {
        ev.preventDefault();
        if (ev.key === pressedKey) {
          releaseHandler();
          node.removeEventListener('keyup', cancel);
          node.addEventListener('keydown', onKeydown);
        }
      };

      node.addEventListener('keyup', cancel);
      // keydown gets fired multiple times when holding down 'Enter'
      // So we remove it on first event and add it again when keyup is fired
      node.removeEventListener('keydown', onKeydown);
    }
  };
  node.addEventListener('keydown', onKeydown);

  return {
    destroy() {
      node.removeEventListener('mousedown', onMouseDown);
      node.removeEventListener('touchstart', onTouchDown);
    },
  };
}
